"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellStationPageContent = void 0;
const react_1 = __importStar(require("react"));
const bannerImage_1 = require("./bannerImage");
const locationInfo_1 = require("./locationInfo");
const useMatchMedia_1 = require("@geome/react-next/lib/hooks/useMatchMedia");
const reorderer_1 = require("@geome/react-components-next/lib/components/reorderer");
const fuels_1 = require("./fuels");
const evCharging_1 = require("./evCharging");
const hydrogen_1 = require("./hydrogen");
const openingHours_1 = require("./openingHours");
const staticMap_1 = require("@geome/react-components-next/lib/components/staticMap");
const cssCustomProperty_1 = require("@geome/react-next/lib/context/cssCustomProperty");
const features_1 = require("./features");
const moreAtThisLocation_1 = require("./moreAtThisLocation");
const about_1 = require("./about");
const details_1 = require("./details");
const nearby_1 = require("./nearby");
const offers_1 = require("./offers");
const stationStatus_1 = require("./stationStatus");
const ShellStationPageContentComponent = (0, react_1.forwardRef)((props, ref) => {
    const { location, nearby } = props;
    return (react_1.default.createElement("div", { "data-testid": "full-page", className: "location-page" },
        react_1.default.createElement("div", { className: "location-page__header", ref: ref },
            react_1.default.createElement(locationInfo_1.LocationInfo, { location: location }),
            react_1.default.createElement(bannerImage_1.BannerImage, { className: "location-page__header-banner-image", siteStatus: location.site_status })),
        react_1.default.createElement(stationStatus_1.StationStatus, { location: location }),
        react_1.default.createElement("div", { className: "content-grid" },
            react_1.default.createElement(ContentGridItems, { location: location }),
            react_1.default.createElement(cssCustomProperty_1.CSSCustomPropertyContextProvider, { properties: {
                    "--item-carousel--item-padding": "10px",
                    "--item-carousel--indicator-size": "15px",
                } },
                location.offers.length > 0 && react_1.default.createElement(offers_1.Offers, { offers: location.offers }),
                nearby.length > 0 && react_1.default.createElement(nearby_1.Nearby, { nearby: nearby })))));
});
const ContentGridItems = ({ location }) => {
    const isDesktopAndAbove = (0, useMatchMedia_1.useMatchMedia)("(min-width: 1023px)");
    const darkMode = (0, useMatchMedia_1.useMatchMedia)("(prefers-color-scheme: dark)");
    const order = (0, react_1.useMemo)(() => (isDesktopAndAbove ? [] : [3]), [isDesktopAndAbove]);
    return (react_1.default.createElement(reorderer_1.Reorderer, { order: order },
        react_1.default.createElement(fuels_1.Fuels, { location: location }),
        react_1.default.createElement(evCharging_1.EvCharging, { data: location.ev_charging }),
        react_1.default.createElement(hydrogen_1.Hydrogen, { location: location }),
        react_1.default.createElement(openingHours_1.OpeningHours, { location: location }),
        react_1.default.createElement(staticMap_1.StaticMap, { static_map_url: location.static_map_url, locationId: location.location_id, locationName: location.name, sectionName: "static_map", configPath: "station_page.", showLogo: true, mode: darkMode ? "dark" : "light" }),
        react_1.default.createElement("div", { className: "properties-container" },
            react_1.default.createElement(cssCustomProperty_1.CSSCustomPropertyContextProvider, { properties: {
                    "--properties-background-colour": "#ffc400",
                } },
                react_1.default.createElement(features_1.Features, { location: location })),
            react_1.default.createElement(cssCustomProperty_1.CSSCustomPropertyContextProvider, { properties: {
                    "--properties-background-colour": "#F6F6F6",
                } },
                react_1.default.createElement(moreAtThisLocation_1.MoreAtThisLocation, { location: location }))),
        react_1.default.createElement("div", { className: "about-details-container" },
            react_1.default.createElement(about_1.About, { location: location }),
            react_1.default.createElement(details_1.Details, { location: location }))));
};
ShellStationPageContentComponent.displayName = "ShellStationPageContent";
exports.ShellStationPageContent = ShellStationPageContentComponent;
